export const LOGIN_NORMAL = "LOGIN_NORMAL";
export const LOGIN_COOKIE = "LOGIN_COOKIE";

export type Role = typeof LOGIN_NORMAL | typeof LOGIN_COOKIE;
export type Roles = Role[];
